import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog-multilines',
  templateUrl: './confirm-dialog-multilines.component.html',
  styleUrls: ['./confirm-dialog-multilines.component.css']
})
export class ConfirmDialogMultilinesComponent implements OnInit {
  response = 'SI';

  constructor(public dialogRef: MatDialogRef<ConfirmDialogMultilinesComponent>,
              @Inject(MAT_DIALOG_DATA) public message: string) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

}
